var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"menu-options__button",class:{'menu-options__button--active' : _vm.isSearchOpen},on:{"click":function($event){$event.stopPropagation();return _vm.toggle.apply(null, arguments)}}},[_c('SearchSVG')],1)}
var staticRenderFns = []

export { render, staticRenderFns }